import {useCallback} from 'react';
import {Mixpanel, UseMixpanelProps} from '@treatwell/ui';
import {useGrowthBook} from '@growthbook/growthbook-react';
import {getDeviceId} from '@treatwell/growthbook-js';

type Props = {
  channelCode: string;
  isProduction: boolean;
};

export const MixpanelContainer = ({channelCode, isProduction}: Props) => {
  const gb = useGrowthBook();

  const mixpanelProps: UseMixpanelProps = {
    isProduction,
    channelCode,
    getMixpanelFlagValues: useCallback(
      () => gb.getFeatureValue('ff-web-frontend__mixpanel-recording', []),
      [gb]
    ),
    getExperimentValue: useCallback(
      (experimentName) => gb.getFeatureValue(experimentName, 'none'),
      [gb]
    ),
    getTrackingDeviceId: useCallback(() => getDeviceId(), []),
  };

  return <Mixpanel {...mixpanelProps} />;
};
